/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { Button } from '@mymoons/ui-library';
import { oxxo, priceCheck } from '../../../../../../assets/images/Global';
import styles from '../../MethodsFlow.module.css';
import data from '../../data';
import axiosPost from '../../../../../../methods/cashPayments/mx/axiosPost';
import ThankYouContext from '../../../../../../context/ThankYou/Context';
import PaymentContext from '../../../../../../context/Payment/Context';
import ProductContext from '../../../../../../context/Product/Context';
import GlobalContext from '../../../../../../context/Global/Context';
import organizeDataPayments from '../../../../../../methods/organizeDataPayments';
import AlertModal from '../../../../../AlertModal';
import { axiosPutRecalculateCarts } from '../../../../../../methods/products/axiosPut';
import { areThereCartsWithoutEnoughStock } from '../../../../../../utils/stock';
import setMixPanelEvent from '../../../../../../utils/setMixPanelEvent';

const FlowOxxo = () => {
  const paymentContext = useContext(PaymentContext);
  const thankYouContext = useContext(ThankYouContext);
  const productContext = useContext(ProductContext);
  const globalContext = useContext(GlobalContext);
  const [loadingOxxoButton, setLoadingOxxoButton] = useState(false);
  const [preventModal, setPreventModal] = useState(false);
  const { titleOxxo, descriptionOxxo, stepsOxxo, buttonOxxo } = data.oxxo;
  const { isCitaFlow, country } = globalContext;
  const { setDataOxxo } = thankYouContext;
  const { hasAddress } = paymentContext;
  const { couponsCode, productsWithDiscount } = productContext;
  let dataToOxxo = organizeDataPayments();
  const carts = new URLSearchParams(window.location.search).getAll('cart');
  const buttonUrl = new URLSearchParams(window.location.search).get(
    'redirectUrl'
  );
  const outOfStockModal = {
    title: '¡Lo sentimos!',
    description:
      'Uno de los productos de tu carrito ya no está disponible. Regresa a la tienda y vuelve a hacer tu selección.',
    button: 'Regresar a la tienda',
    imgAlert: priceCheck,
    urlRedirect: buttonUrl,
    discardLink: buttonUrl,
  };

  useEffect(() => {
    if (productsWithDiscount.length !== 0) {
      const productsArray = [];

      productsWithDiscount.forEach((product) => {
        const { images } = product.variant;
        const { centAmount } = product.price.value;
        const { centAmount: centAmountDiscounted } =
          product.discountedPricePerQuantity[0].discountedPrice.value;
        const productsConvert = {
          id: product.id,
          productId: product.productId,
          name: 'es-MX',
          price: centAmountDiscounted,
          quantity: product.quantity,
          totalPrice: centAmount * product.quantity,
          images,
        };
        productsArray.push(productsConvert);
      });

      dataToOxxo.cartData.totalLineItemQuantity = productsArray.length;
      dataToOxxo.cartData.lineItems = productsArray;
    }
  }, [couponsCode]);

  const getOxxoReference = () => {
    setMixPanelEvent(country, 'Main Oxxo Payment Button');
    (async () => {
      try {
        const { data: upToDateCartData } = await axiosPutRecalculateCarts(
          carts
        );

        if (areThereCartsWithoutEnoughStock(upToDateCartData.carts)) {
          setPreventModal(true);
        } else {
          setPreventModal(false);
          dataToOxxo.country = 'México';
          dataToOxxo.discountPrice = couponsCode.length > 0 ? true : false;
          dataToOxxo.paymentMethodType = 'oxxo';
          dataToOxxo.transactionType = 'product';
          setLoadingOxxoButton(true);
          axiosPost(dataToOxxo)
            .then((res) => {
              setDataOxxo(res.data);
              setMixPanelEvent(country, 'Main Oxxo Payment Success');
              setLoadingOxxoButton(false);
              window.location.replace(`${window.location.origin}/payment/oxxo`);
            })
            .catch(() => {
              setMixPanelEvent(country, 'Main Oxxo Payment Failure');
              setLoadingOxxoButton(false);
            });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        setPreventModal(false);
      }
    })();
  };

  return (
    <>
      {preventModal && (
        <AlertModal
          data={outOfStockModal}
          modal={false}
          discardOption={false}
        />
      )}
      <div className={styles.titleContainer}>
        <p className={styles.title}>{titleOxxo}</p>
        <img
          className={styles.logo}
          width={44}
          height={18}
          src={oxxo}
          alt="Oxxo Logo"
        />
      </div>
      <div className={styles.container}>
      <p className={styles.text}>{descriptionOxxo}</p>
        <ul className={styles.list}>
          {stepsOxxo.map((step, index) => (
            <li key={step} className={styles.text}>
              <div className={styles.circle}>{index + 1}</div>
              <div className={styles.stepText}>{step}</div>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.button}>
        {!hasAddress && !isCitaFlow ? (
          <p className={styles.textPreventAddress}>
            Agrega una dirección de envío para continuar.
          </p>
        ) : null}
        <Button
          id="Check_Flow_GetReferenceOxxo"
          color="red"
          disabled={!hasAddress && !isCitaFlow ? true : false}
          fullWidth
          isButton
          label={buttonOxxo}
          rel="noopener noreferrer"
          size="medium"
          variant="filled"
          loading={loadingOxxoButton}
          onClick={() => getOxxoReference()}
        />
      </div>
    </>
  );
};

export default FlowOxxo;
